"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitMultiCellsWithSecp256k1 = void 0;
const ckb_sdk_utils_1 = require("@nervosnetwork/ckb-sdk-utils");
const error_1 = require("../error");
const constants_1 = require("../constants");
const utils_1 = require("../utils");
const SECP256K1_MIN_CAPACITY = BigInt(61) * constants_1.CKB_UNIT;
const splitMultiCellsWithSecp256k1 = (_a) => __awaiter(void 0, [_a], void 0, function* ({ masterPrivateKey, collector, receiverAddress, capacityWithCKB, cellAmount, }) {
    const isMainnet = receiverAddress.startsWith('ckb');
    const masterAddress = (0, ckb_sdk_utils_1.privateKeyToAddress)(masterPrivateKey, {
        prefix: isMainnet ? ckb_sdk_utils_1.AddressPrefix.Mainnet : ckb_sdk_utils_1.AddressPrefix.Testnet,
    });
    const masterLock = (0, ckb_sdk_utils_1.addressToScript)(masterAddress);
    let emptyCells = yield collector.getCells({
        lock: masterLock,
    });
    if (!emptyCells || emptyCells.length === 0) {
        throw new error_1.NoLiveCellError('The address has no empty cells');
    }
    emptyCells = emptyCells.filter((cell) => !cell.output.type);
    const cellCapacity = BigInt(capacityWithCKB) * constants_1.CKB_UNIT;
    const needCapacity = cellCapacity * BigInt(cellAmount);
    const txFee = constants_1.MAX_FEE;
    const { inputs, sumInputsCapacity } = collector.collectInputs(emptyCells, needCapacity, txFee, {
        minCapacity: SECP256K1_MIN_CAPACITY,
    });
    const outputs = new Array(cellAmount).fill({
        lock: (0, ckb_sdk_utils_1.addressToScript)(receiverAddress),
        capacity: (0, utils_1.append0x)(cellCapacity.toString(16)),
    });
    const changeCapacity = sumInputsCapacity - needCapacity - txFee;
    outputs.push({
        lock: masterLock,
        capacity: (0, utils_1.append0x)(changeCapacity.toString(16)),
    });
    const outputsData = new Array(cellAmount + 1).fill('0x');
    const emptyWitness = { lock: '', inputType: '', outputType: '' };
    const witnesses = inputs.map((_, index) => (index === 0 ? emptyWitness : '0x'));
    const cellDeps = [(0, constants_1.getSecp256k1CellDep)(isMainnet)];
    const unsignedTx = {
        version: '0x0',
        cellDeps,
        headerDeps: [],
        inputs,
        outputs,
        outputsData,
        witnesses,
    };
    if (txFee === constants_1.MAX_FEE) {
        const txSize = (0, ckb_sdk_utils_1.getTransactionSize)(unsignedTx) + constants_1.SECP256K1_WITNESS_LOCK_SIZE;
        const estimatedTxFee = (0, utils_1.calculateTransactionFee)(txSize);
        const estimatedChangeCapacity = changeCapacity + (constants_1.MAX_FEE - estimatedTxFee);
        unsignedTx.outputs[unsignedTx.outputs.length - 1].capacity = (0, utils_1.append0x)(estimatedChangeCapacity.toString(16));
    }
    const signedTx = collector.getCkb().signTransaction(masterPrivateKey)(unsignedTx);
    const txHash = yield collector.getCkb().rpc.sendTransaction(signedTx, 'passthrough');
    console.info(`Paymaster cells has been split and tx hash is ${txHash}`);
});
exports.splitMultiCellsWithSecp256k1 = splitMultiCellsWithSecp256k1;
